module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-news-pc"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('div', {
    staticClass: "sologan"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "news-deal-pc"
  }, [_c('img', {
    staticClass: "main-title",
    attrs: {
      "src": require("../../assets/img2/pc/news/title_trans.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deal-list"
  }, [_vm._l((_vm.dealList), function(item) {
    return _c('a', {
      staticClass: "deal-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "logo-area"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.banner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._m(0, true, false)])
  }), _vm._v(" "), _vm._l((10), function(i) {
    return (false) ? _c('div', {
      staticClass: "deal-item"
    }, [_vm._m(1, true, false), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(" 凡卓资本成功帮助超过 600家创业公司完成融资 ")]), _vm._v(" "), _vm._m(2, true, false)]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fzg-recent-activity"
  }, [_c('a', {
    attrs: {
      "name": "activity"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "activity-title",
    attrs: {
      "src": require("../../assets/img2/pc/news/title_activity.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fzg-activity-wrap"
  }, [_c('div', {
    staticClass: "activity-left"
  }, [_c('a', {
    attrs: {
      "href": _vm.firstActivityNews.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.firstActivityNews.banner,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-title-area"
  }, [_c('div', {
    staticClass: "l-date"
  }, [_vm._v(_vm._s(_vm.firstActivityNews.date) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "l-title"
  }, [_vm._v(_vm._s(_vm.firstActivityNews.title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-right"
  }, _vm._l((_vm.activityNewsList), function(item, index) {
    return (index > 0 && index < 4) ? _c('div', {
      staticClass: "right-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "r-item-date"
    }, [_vm._v(_vm._s(item.date) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "r-item-title"
    }, [_vm._v(_vm._s(item.title.substr(0, 40)))]), _vm._v(" "), _c('div', {
      staticClass: "r-item-content"
    }, [_vm._v(_vm._s(item.brief.length > 50 ? item.brief.substr(0, 50) + '...' : item.brief))])])]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "fzg-activity"
  }, [_c('img', {
    staticClass: "title-activity",
    attrs: {
      "src": require("../../assets/img2/pc/news/title_news.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-area"
  }, [_vm._l((_vm.groupNewsList), function(item) {
    return _c('div', {
      staticClass: "act-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "act-icon"
    }, [_c('img', {
      attrs: {
        "src": item.banner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-content"
    }, [_c('div', {
      staticClass: "act-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "act-content"
    }, [_vm._v(_vm._s(item.content.length > 40 ? item.content.substr(0, 40) + '...' : item.content))])])])])
  }), _vm._v(" "), _vm._l((10), function(item) {
    return (false) ? _c('div', {
      staticClass: "act-item"
    }, [_c('img', {
      staticClass: "act-icon",
      attrs: {
        "src": require("../../assets/img2/pc/fzg-bussiness-icon1.jpg"),
        "alt": ""
      }
    }), _vm._v(" "), _vm._m(3, true, false)]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-num"
  }, _vm._l((_vm.groupNewsPageData.total_page), function(page) {
    return _c('span', {
      class: {
        'active': page == _vm.currentNewsPage
      },
      on: {
        "click": function($event) {
          _vm.changeNewsPage(page)
        }
      }
    }, [_vm._v(" " + _vm._s(page))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-plus"
  }, [_c('img', {
    staticClass: "icon-plus",
    attrs: {
      "src": require("../../assets/img2/pc/news/icon-add.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-area"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/fa/fa_data_1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-plus"
  }, [_c('img', {
    staticClass: "icon-plus",
    attrs: {
      "src": require("../../assets/img2/pc/news/icon-add.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "act-title"
  }, [_vm._v("「蔚领时代」完成4000万美元B2轮融资，凡卓资本担任财务顾问")]), _vm._v(" "), _c('div', {
    staticClass: "act-content"
  }, [_vm._v("国内第一批创投服务机构，拥有包含小饭桌ROADSHOW、、社群等明星产品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-511fff95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/FzgNewsPc.vue
// module id = 225
// module chunks = 0